import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, CircularProgress, Button } from "@mui/material";
import BASE_URL from "../../components/config/appconfig";
import usePageMeta from "../../utils/usePageMeta";

const PaymentSuccess = () => {
  usePageMeta(
    "Payment Successful",
    "Your payment for the Gospel and Church Health Framework has been processed.",
  );
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(null);

  useEffect(() => {
    const handlePayment = async () => {
      console.log("Starting payment processing...");

      let userData = null;
      try {
        userData = JSON.parse(localStorage.getItem("userData"));
      } catch (e) {}
      console.log("LocalStorage userData:", userData);

      if (!userData) {
        setLoading(false);
        setMessage("Session expired. Please log in again.");
        setIsSuccess(false);
        console.warn("No userData found in localStorage.");
        return;
      }

      // Call backend to verify payment and update status
      try {
        const res = await fetch(`${BASE_URL}/api/payment/verify`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: userData.email }),
        });

        console.log("Response status:", res.status);
        const result = await res.json();
        console.log("Response JSON:", result);

        if (result.success) {
          // Update the local storage so routing lets them through
          const updatedUser = { ...userData, payment_status: "verified" };
          localStorage.setItem("userData", JSON.stringify(updatedUser));

          setMessage(
            result.message || "Payment verified! Redirecting to Framework...",
          );
          setIsSuccess(true);
          console.log(
            "Payment verified successfully, navigating to verification...",
          );
          setTimeout(() => navigate("/verification"), 3000);
        } else {
          setMessage(
            result.message ||
              "Payment verification failed. Please contact support.",
          );
          setIsSuccess(false);
          console.error("Verification failed:", result.message);
        }
      } catch (err) {
        console.error("Error during payment processing:", err);
        setMessage("Something went wrong while completing your payment.");
        setIsSuccess(false);
      } finally {
        setLoading(false);
      }
    };

    handlePayment();
  }, [navigate]);
  return (
    <Box
      sx={{
        minHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: 2,
      }}
    >
      {loading ? (
        <>
          <CircularProgress sx={{ mb: 2, color: "#ED1C2E" }} />
          <Typography variant="h6">Processing your payment...</Typography>
        </>
      ) : (
        <>
          <Typography variant="h4" sx={{ fontWeight: 600, mb: 2 }}>
            {isSuccess === true
              ? "Payment Successful 🎉"
              : isSuccess === false
                ? "Payment Failed ❌"
                : "Processing your payment..."}
          </Typography>
          <Typography sx={{ maxWidth: 500, color: "#555", mb: 3 }}>
            {message}
          </Typography>

          {!loading && isSuccess === false && (
            <Button
              variant="contained"
              onClick={() => navigate("/payment")}
              sx={{ bgcolor: "#ED1C2E", "&:hover": { bgcolor: "#c81a26" } }}
            >
              Try Again
            </Button>
          )}
        </>
      )}
    </Box>
  );
};

export default PaymentSuccess;
